import React, { useState, useEffect } from 'react';
import { useSaleRoModel } from "../saleRoModel";
import { YhPrint } from "@/components/YhPrint";
import { saleRoService } from '../saleRoService';
import { IDetailList, ISaleRoDetail } from '../saleRoTypes';
import { formatNum, formatIntPoint, numberParseChina } from '@/utils/utils';
import moment from 'moment';

export function Print() {
    const { print, setPrint,onPrinting, selectedRow } = useSaleRoModel();
    const [formVal, setFormVal] = useState<ISaleRoDetail>();
    const [goodsList, setGoodsList] = useState<IDetailList[]>([]);

    useEffect(() => {
        print && getPoDetailOne()
    }, [print])

    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleRoService.one(selectedRow.returnCode as string);
        let { details, ...formVal } = retData;
        // let newDetails = details?.map((item)=>()
        let newDetails = details?.map((item, index) => ({
            ...item,
            No: index + 1,
            notAmount: Number(item.num) * Number(item.price)
        }))
        if (retData) {
            setGoodsList(newDetails as IDetailList[] ?? [])
            setFormVal(formVal)
        }
    };

    const columns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            title: 'PART NO零件号 رقم القطع',
            dataIndex: 'materialCode',
        },
        {
            title: 'Description零件名称 أسم القطع ',
            dataIndex: 'materialName',
        },
        {
            title: 'Quantity数量 كيمة  ',
            dataIndex: 'num',
        },
        {
            title: 'Unit price单价  SR أسعار ',
            dataIndex: 'price',
        },
        {
            title: ' Amount总价 أجمالي ',
            dataIndex: 'notAmount',
        }
    ]

    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "VAT NO增值税号",
                fieldValue: " "
            },
            {
                fieldLabel: "单据编号",
                fieldValue: formVal?.returnCode,
            },
            {
                fieldLabel: "CUSTOMER NAME 顾客姓名: اسم العميل",
                fieldValue: formVal?.customerName,
                border: true,
            },
            {
                fieldLabel: "INVOICE DATE发票日期:  التاريخ",
                fieldValue: moment(formVal?.createTime).format("DD/MM/YYYY"),
                border: true,
            },
            {
                fieldLabel: "地址 العنوان",
                fieldValue: formVal?.address,
                border: true,
            },
            {
                fieldLabel: "Ref No参考编号 :",
                fieldValue: "",
                border: true,
            },
        ],
        footer: [
            {
                fieldLabel: "Prepared",
                fieldValue: ""
            },
            {
                fieldLabel: "Prepared",
                fieldValue: ""
            },
            {
                fieldLabel: "Approved批准",
                fieldValue: ""
            },
        ],
        totalAmount: [
            {
                fieldLabel: "SUBTOTAL合计金额 اجمالي",
                fieldValue: formVal?.totalAmount,
            },
            {
                fieldLabel: "TOTAL 总金额 اجمالي",
                fieldValue: formVal?.totalAmount,
            },
            {
                fieldLabel: "VAT 15%  税费 الضريبة",
                fieldValue: Number(formVal?.totalAmount) * 0.15,
            },
            {
                fieldLabel: " NET TOTAL 最终金额 الصافي",
                fieldValue:  (Number(formVal?.totalAmount) * 1.15).toFixed(2),
            },
        ]
    }
    const onCancel = () => {
        setPrint(false)
        setGoodsList([]);
        setFormVal({})
    }
    const onConfirm = async () => {
        let { id, returnCode } = selectedRow
        await onPrinting({ id, returnCode })
    }
    return (
        <YhPrint
            title=""
            type=""
            visible={print}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            dataSource={goodsList}
            printShow={printShow}
        />
    );
}

export default Print;
